import React from "react";
import { Footer } from "rsuite";
import { APP_VERSION } from "../../../../config/config.js";
import userManual from "../../../../docs/RINF-User Manual v2.2.1.pdf";
export default function RedesignFooter() {
    return (React.createElement(Footer, { className: "redesign-shell-footer" },
        React.createElement("nav", { "aria-label": "Footer" },
            React.createElement("a", { href: userManual }, "User Manual"),
            React.createElement("span", { className: "redesign-shell-footer-separator", "aria-hidden": "true" }, " · "),
            React.createElement("span", null, "Legal"),
            React.createElement("span", { className: "redesign-shell-footer-separator", "aria-hidden": "true" }, " · "),
            React.createElement("a", { href: "https://www.era.europa.eu/content/data-protection" }, "Privacy statement"),
            React.createElement("span", { className: "redesign-shell-footer-separator", "aria-hidden": "true" }, " · "),
            React.createElement("span", null, "Terms of reference"),
            React.createElement("span", { className: "redesign-shell-footer-separator", "aria-hidden": "true" }, " · "),
            React.createElement("span", null, "Support")),
        React.createElement("span", null,
            "\u00A9 2026 European Union Agency for Railways \u00B7 ",
            APP_VERSION)));
}
